export const userGuides = (state) => state.userGuides
export const selectAllField = (state) => state.selectAllField
export const selectedUserGuides = (state) => state.selectedUserGuides
export const totalUserGuides = (state) => state.totalUserGuides
export const viewUserGuide = (state) => state.viewUserGuide